import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api, setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(undefined);

  const appliquer = useCallback((data) => {
    setToken(data.token);
    setAuth({ user: data.utilisateur, perms: data.permissions, roleLabel: data.role_label, impersonation: data.impersonation || null });
  }, []);

  const rafraichir = useCallback(async () => {
    const r = await api.get("/auth/me");
    setAuth({ user: r.data.utilisateur, perms: r.data.permissions, roleLabel: r.data.role_label, impersonation: r.data.impersonation || null });
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setAuth(null); return; }
    if (!localStorage.getItem("idcore_token")) { setAuth(null); return; }
    setToken(localStorage.getItem("idcore_token"));
    rafraichir().catch(() => { clearToken(); setAuth(null); });
  }, [rafraichir]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    appliquer(r.data);
    return r.data;
  };

  const loginGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    clearToken();
    localStorage.removeItem("idcore_admin_token");
    setAuth(null);
  };

  const impersonate = async (userId) => {
    const r = await api.post("/admin/impersonate", { user_id: userId });
    localStorage.setItem("idcore_admin_token", localStorage.getItem("idcore_token"));
    appliquer({ ...r.data, impersonation: { admin_nom: auth?.user?.nom || "Admin" } });
  };

  const stopImpersonation = async () => {
    const adminToken = localStorage.getItem("idcore_admin_token");
    if (adminToken) {
      setToken(adminToken);
      localStorage.removeItem("idcore_admin_token");
      await rafraichir();
    }
  };

  const peutVoir = (m) => (auth?.perms?.[m] || "masque") !== "masque";
  const peutEcrire = (m) => auth?.perms?.[m] === "ecriture";

  return (
    <AuthContext.Provider value={{ auth, appliquer, login, loginGoogle, logout, impersonate, stopImpersonation, peutVoir, peutEcrire }}>
      {children}
    </AuthContext.Provider>
  );
}
